import { createSlice } from "@reduxjs/toolkit";
import axios from "../utils/axios";
import { meetingActions } from "./meeting";
import { recordingStatus, setRecordingStatus } from "./presenter";
import jwt_decode from "jwt-decode";
interface ICommunicatorState {
  eventData?: boolean;
  threadId: number;
}

const initialState: ICommunicatorState = {
  eventData: true,
  threadId: null,
};

const slice = createSlice({
  name: "events",
  initialState,
  reducers: {
    getEventDetails(state, action) {
      state.eventData = action.payload;
    },
    getThreadId(state, action) {
      state.threadId = action.payload;
    },
  },
});

export const reducer = slice.reducer;

export const getEventDetails = () => async (dispatch) => {
  setTimeout(() => {
    dispatch(slice.actions.getEventDetails(false));
  }, 2000);
};

export const getThreadDetails = (data) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/events/api/v1/events?id=${data}`
    );
    dispatch(slice.actions.getThreadId(response?.data?.data[0]?.threadId));
    dispatch(meetingActions.createdById(response?.data?.data[0]?.userId));
    //This is to check if recording is on or not which should not be reflected on recorder user
    const token = localStorage.getItem("token");
    const tokenData: any = jwt_decode(token);
    const loggedInEmail = tokenData?.email;
    if (
      loggedInEmail === "recorder@yopmail.com" &&
      response?.data?.data?.[0]?.recordings?.status === "requested_stop"
    ) {
      dispatch(setRecordingStatus("started"));
    }
    if (loggedInEmail !== "recorder@yopmail.com") {
      if (response?.data?.data?.[0]?.recordings?.status === "requested") {
        dispatch(setRecordingStatus("starting"));
      } else if (
        response?.data?.data?.[0]?.recordings?.status === "requested_stop"
      ) {
        dispatch(setRecordingStatus("saving"));
      } else if (response?.data?.data?.[0]?.recordings?.status === "started") {
        dispatch(recordingStatus(true));
        dispatch(setRecordingStatus("started"));
      } else if (response?.data?.data?.[0]?.recordings?.status === "idle") {
        dispatch(setRecordingStatus("ended"));
      }
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const fetchRecorderEventDetails = (id: string) => async (dispatch) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/events/api/v1/events?id=${id}`
    );
    if (response?.data?.data?.[0]?.recordings?.status === "started") {
      dispatch(recordingStatus(true));
      dispatch(setRecordingStatus("started"));
    }
  } catch (error) {
    throw new Error(error);
  }
};

export const eventSession = (id: string) => async () => {
  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/events/api/v1/events/event-session`,
      { clientId: id }
    );
  } catch (error) {
    //
  }
};

export const questionNotSubmitted = async (id: string) => {
  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/events/api/v1/question/${id}/question-not-submitted`
    );
  } catch (error) {
    // 
     throw new Error(error);
  }
};

export default slice;
